<br>

<app-notification-system [users]="registrations"></app-notification-system>